export const UPGRADE_CARD_DISMISSED_KEY = "upgrade_card_dismissed";
